import { Category } from '@/common/types/databaseTypes';
import { supabase, i18n } from '@tickitacka/shared';

// common.json에 정의된 카테고리 번역 키 매핑
export const CATEGORY_KEY_MAP: Record<string, string> = {
    'Basic 1': 'field.category.work',
    'Basic 2': 'field.category.meeting',
    'Basic 3': 'field.category.communication',
    'Basic 4': 'field.category.study',
    'Basic 5': 'field.category.rest',
    'Basic 6': 'field.category.etc',
};

class CategoryService {
    async getAllCategories(): Promise<Category[]> {
        try {
            const { data, error } = await supabase
                .from('category')
                .select('*')
                .eq('enable', true)
                .order('name');

            if (error) throw error;
            
            const categoriesWithDisplayNames = data?.map(category => {
                // common.json에서 정의된 번역 키 가져오기
                const translationKey = CATEGORY_KEY_MAP[category.name];
                // shared에서 가져온 i18n을 사용하여 현재 언어에 맞는 번역 가져오기
                const translatedName = translationKey ? i18n.t(translationKey) : category.name;

                return {
                    ...category,
                    displayName: translatedName
                };
            }) || [];

            return categoriesWithDisplayNames;
        } catch (error) {
            console.error('Failed to fetch categories', error);
            throw error;
        }
    }
}

export const categoryService = new CategoryService();
